/**
 * Triple Whale Pixel storefront configuration, served by BBNT_TripleWhaleEvents through
 * `bbnt_analytics_configuration.triplewhale` (store-scoped, PII-free).
 */
export interface AnalyticsConfiguration_TripleWhale {
  enabled?: boolean;
  shop?: string;
  contractVersion?: number;
  customEventsEnabled?: boolean;
  funnelEventsEnabled?: boolean;
  cartIdentityUrl?: string;
  /** ISO 4217 code of the store view's display currency (cart-valued custom events). */
  currency?: string;
}

export const AnalyticsConfiguration_TripleWhale_Graphql_Request_Fragment = `
  enabled
  shop
  contractVersion
  customEventsEnabled
  funnelEventsEnabled
  cartIdentityUrl
  currency
`;
